var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ls-flex grow-3",
      attrs: { id: "QuestionEditor--test--questionoverviewcontainer" }
    },
    [
      _c("transition", { attrs: { name: "slide-fade" } }, [
        !_vm.loading
          ? _c(
              "div",
              {
                staticClass: "panel panel-default col-12",
                on: { dblclick: _vm.toggleEditMode }
              },
              [
                _c("div", { staticClass: "panel-heading" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm._f("translate")("Text elements")) +
                      "\n            "
                  )
                ]),
                _c("ul", { staticClass: "list-group" }, [
                  _c("li", { staticClass: "list-group-item" }, [
                    _c("div", { staticClass: "ls-flex-row wrap col-12" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _vm._v(_vm._s(_vm._f("translate")("Question")))
                      ]),
                      _c("div", {
                        staticClass: "col-12 scoped-small-border",
                        domProps: {
                          innerHTML: _vm._s(_vm.cleanCurrentQuestion)
                        }
                      })
                    ])
                  ]),
                  _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !!_vm.cleanCurrentQuestionHelp,
                          expression: "!!cleanCurrentQuestionHelp"
                        }
                      ],
                      staticClass: "list-group-item"
                    },
                    [
                      _c("div", { staticClass: "ls-flex-row wrap col-12" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _vm._v(_vm._s(_vm._f("translate")("Help")))
                        ]),
                        _c("div", {
                          staticClass: "col-12 scoped-small-border",
                          domProps: {
                            innerHTML: _vm._s(_vm.cleanCurrentQuestionHelp)
                          }
                        })
                      ])
                    ]
                  ),
                  _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !!_vm.currentQuestionScript,
                          expression: "!!currentQuestionScript"
                        }
                      ],
                      staticClass: "list-group-item"
                    },
                    [
                      _c("div", { staticClass: "ls-flex-row wrap col-12" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _vm._v(_vm._s(_vm._f("translate")("Script")))
                        ]),
                        _c(
                          "div",
                          { staticClass: "col-12 scoped-small-border" },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.currentQuestionScript) +
                                "\n                        "
                            )
                          ]
                        ),
                        _c("p", { staticClass: "alert well" }, [
                          _vm._v(_vm._s(_vm._f("translate")("__SCRIPTHELP")))
                        ])
                      ])
                    ]
                  )
                ])
              ]
            )
          : _vm._e()
      ]),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.loading
          ? _c(
              "div",
              { staticClass: "row" },
              [
                _c("loader-widget", { attrs: { id: "questionoverviewLoader" } })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }